<script setup lang="ts">
import { Link } from "@inertiajs/vue3";
import { type Cta, } from "@/helpers/builder-init/index";
import { getCtaLink } from "@/helpers/interfaces/Cta";
import { computed } from "vue";
let props = defineProps<{
    togglePadding: boolean;
    columns: string;
    categories: Array<{
        headline: string;
        cta: Cta;
    }>
}>();

let columnNumber = computed(() => {
        if (props.columns == "two") {
            return "";
        } else {
            return props.columns;
        }
    })
</script>
<template>
     <section
            id="category_launcher"
            :class="{
                'missing-images': true,
                'category-launchers': true,
                [columnNumber]: !!columnNumber,
                'alternative-padding': !props.togglePadding
            }"
        >
        <div
            v-for="(category, index) in props.categories"
            :key="index"
            class="category-launchers-item"
        >
            <Link
                :key="index"
                as="button"
                :href="getCtaLink(category.cta).href"
                >{{ category.headline }}</Link
            >
        </div>
    </section>
</template>